/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMutation } from '@apollo/client'
import { Hidden, Typography, Fade } from '@material-ui/core'
import React, { Fragment, useState } from 'react'
import { toast } from 'react-toastify'

import NoDataImage from '../../assets/images/NoDataWithNoText.png'
import { DELETE_CHANNEL_API_KEY } from '../../graphql/deleteChannelAPIKey'
import { getTranslate } from '../../localization'
import { ChannelAPIKeys } from '../../types/channelAPIKeys'
import UserAPIKeyRow from './UserAPIKeyRow'
import UserAPIKeyRowSkeleton from './UserAPIKeyRow.skeleton'
import UserAPIKeyRowMobile from './UserAPIKeyRowMobile'
import useStyles from './index.styles'

interface ChannelAPIKeysListProps {
  loading: boolean
  refetch: () => void
  data: ChannelAPIKeys[]
  hasAccessToModifyChannelApiKeys?: boolean | undefined
}
const ChannelAPIKeysList: React.FC<ChannelAPIKeysListProps> = ({
  loading,
  refetch,
  data,
  hasAccessToModifyChannelApiKeys
}) => {
  const classes = useStyles()

  const [current, setCurrent] = useState<string>('')

  const [deleteAPIKey, { loading: pendingForDeletion }] = useMutation(
    DELETE_CHANNEL_API_KEY
  )
  const deleteAPIKeyFunction = (input: ChannelAPIKeys, index: number) => {
    setCurrent(data[index].id)
    deleteAPIKey({
      variables: {
        channelId: data[index].entityId,
        apikeyID: input.id,
        apikey: input.key,
        description: input.description
      }
    })
      .then(({ data: response }) => {
        toast.success(response.deleteChannelAPIKeys.message)
        refetch()
      })
      .catch((response) => toast.error(response.message))
  }

  return (
    <div>
      <Hidden smDown>
        <div className={classes.tableHead}>
          <div>
            <Typography variant="body1">
              {getTranslate('Expires At')}
            </Typography>
          </div>
          <div>
            <Typography variant="body1">{getTranslate('API Key')}</Typography>
          </div>
          <div style={{ paddingLeft: '3%' }}>
            <Typography variant="body1">
              {getTranslate('Description')}
            </Typography>
          </div>
          <div />
        </div>
      </Hidden>
      {loading ? (
        Array(2)
          .fill(null)
          .map((_, index) => <UserAPIKeyRowSkeleton key={index.toString()} />)
      ) : data.length ? (
        data.map((item, index: number) => (
          <Fragment key={item.id}>
            <Hidden smDown>
              <Fade in timeout={600}>
                <UserAPIKeyRow
                  hasAccessToModifyChannelApiKeys={
                    hasAccessToModifyChannelApiKeys
                  }
                  index={index}
                  currentID={current}
                  data={item}
                  deleteFunction={deleteAPIKeyFunction}
                  pendingForDeletion={pendingForDeletion}
                />
              </Fade>
            </Hidden>
            <Hidden mdUp>
              <Fade in timeout={600}>
                <UserAPIKeyRowMobile
                  hasAccessToModifyChannelApiKeys={
                    hasAccessToModifyChannelApiKeys
                  }
                  index={index}
                  currentID={current}
                  pendingForDeletion={pendingForDeletion}
                  data={item}
                  deleteFunction={deleteAPIKeyFunction}
                />
              </Fade>
            </Hidden>
          </Fragment>
        ))
      ) : (
        <div className={classes.noDataImageContainer}>
          <img src={NoDataImage} />
          <Typography variant="subtitle1">
            {getTranslate('No Documents')}
          </Typography>
        </div>
      )}
    </div>
  )
}

export default ChannelAPIKeysList
